"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const polaris_1 = require("@shopify/polaris");
const blankBackground_webp_1 = __importDefault(require("assets/images/blankBackground.webp"));
const HeroImage_1 = __importDefault(require("components/onboarding/HeroImage"));
const OnboardingForm_1 = __importDefault(require("components/onboarding/OnboardingForm"));
const StyledImageBackground_1 = require("components/onboarding/styles/StyledImageBackground");
const paymentMethodCopy_1 = require("copy/paymentMethodCopy");
const GenericInput_1 = __importDefault(require("components/general/inputs/GenericInput"));
const EmptyState = () => {
    const noop = (e) => __awaiter(void 0, void 0, void 0, function* () {
        e.preventDefault();
        return;
    });
    const linkProps = {
        preface: paymentMethodCopy_1.paymentMethodCopy.linkPreface,
        href: paymentMethodCopy_1.paymentMethodCopy.linkHref,
        prompt: paymentMethodCopy_1.paymentMethodCopy.linkPrompt
    };
    return (react_1.default.createElement(StyledImageBackground_1.StyledImageBackground, { id: 'payment_method', url: blankBackground_webp_1.default },
        react_1.default.createElement(OnboardingForm_1.default, { contactLink: linkProps, cta: paymentMethodCopy_1.paymentMethodCopy.cta, header: paymentMethodCopy_1.paymentMethodCopy.header, inputs: [
                react_1.default.createElement(polaris_1.BlockStack, { gap: '100', key: 'skeleton' },
                    react_1.default.createElement(polaris_1.SkeletonBodyText, { lines: 1 }),
                    react_1.default.createElement(GenericInput_1.default, { disabled: true }),
                    react_1.default.createElement(polaris_1.SkeletonBodyText, { lines: 1 }),
                    react_1.default.createElement(GenericInput_1.default, { disabled: true }),
                    react_1.default.createElement(polaris_1.SkeletonBodyText, { lines: 1 }),
                    react_1.default.createElement(GenericInput_1.default, { disabled: true }),
                    react_1.default.createElement(polaris_1.SkeletonBodyText, { lines: 2 }))
            ], loading: true, onFormSubmit: noop }),
        react_1.default.createElement(HeroImage_1.default, { header: paymentMethodCopy_1.paymentMethodCopy.heroHeader, subheader: paymentMethodCopy_1.paymentMethodCopy.heroSubHeader })));
};
exports.default = EmptyState;
